import PropTypes from 'prop-types';
import React from 'react';
import CardHeader from 'react/shared/components/true_link/lab/form/wizard/CardHeader';
import CardText from 'react/shared/components/true_link/lab/form/wizard/CardText';
import TrueLinkRadios from 'react/shared/components/true_link/main/form/TrueLinkRadios';
import AtmAccessInfo from 'react/signups/card/common/AtmAccessInfo';
import ErrorText from 'react/signups/card/common/ErrorText';
import cardProgramQuestionsShape from 'react/signups/card/shapes/CardProgramQuestions';
import triStateBooleanShape from 'react/signups/card/shapes/TriStateBoolean';

export default function CardProgramForm({ onChange, values, firstName, cardProgramQuestions }) {
  const options = [
    {
      label: 'Yes',
      value: 'yes',
    },
    {
      label: 'No',
      value: 'no',
    },
  ];

  // To see the atm access step it must be requested to be shown from the backend
  // and either they don't see the trust question or respond no.
  const showCardProgram =
    cardProgramQuestions.atm_access === true &&
    (cardProgramQuestions.funded_from_trust === false || values.fundedByTrust === 'no');

  return (
    <>
      {cardProgramQuestions.funded_from_trust === true && (
        <>
          <div id="special_needs_trust_question">
            <CardHeader>
              Will {firstName} use this card to spend funds from a Special Needs Trust?
            </CardHeader>
            <CardText>
              A special needs trust is a specific legal arrangement. If you select "Yes", we can
              provide a specific type of card for this situation.
            </CardText>
            <CardText>Please select "No" if you are not familiar with this.</CardText>
            <TrueLinkRadios
              ariaLabel="Will you get funds from a special needs trust questionnaire"
              name="fundedByTrust"
              onChange={onChange}
              options={options}
              value={values.fundedByTrust}
            />
          </div>
          <ErrorText name="fundedByTrust" />
        </>
      )}
      {showCardProgram && (
        <div id="atm_access_question">
          <CardText>
            Will {firstName} be making cash withdrawals from ATMs using this card?
          </CardText>
          <TrueLinkRadios
            ariaLabel="Do you need ATM access questionnaire"
            name="atmAccess"
            onChange={onChange}
            options={options}
            value={values.atmAccess}
          />
          <ErrorText name="atmAccess" />
          <AtmAccessInfo atmAccess={values.atmAccess} />
        </div>
      )}
    </>
  );
}

CardProgramForm.propTypes = {
  cardProgramQuestions: cardProgramQuestionsShape.isRequired,
  firstName: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  values: PropTypes.shape({
    atmAccess: triStateBooleanShape.isRequired,
    fundedByTrust: triStateBooleanShape.isRequired,
  }).isRequired,
};
